import { rootUrl as baseUrl } from './shared';
export const website = {
  '@context': 'http://schema.org',
  '@type': 'WebSite',
  '@id': `${baseUrl}/#website`,
  url: `${baseUrl}`,
  publisher: {
    '@id': `${baseUrl}/#organization`
  }
};
